import { MdModeEditOutline } from "react-icons/md";
import { Epic } from "../../types/epic";
import convertSeconds from "../../utils/convertSecond";

type MovieInfoProps = {
  epicData?: Epic;
};

function MovieInfo({ epicData }: MovieInfoProps) {
  const toggleSubtitleModal = () => {
    const modalHandler = document?.querySelector(
      "#editSubtitleModal"
    ) as HTMLElement;
    modalHandler.click();
    return;
  };
  return (
    <div className="movie-info flex flex-wrap columns-3">
      <span className="text-md my-2 xl:w-4/12 md:w-1/2 w-full">
        اسم فیلم: {epicData?.subject}
      </span>
      {epicData?.factory_movie_creator && (
        <span className="text-md my-2 xl:w-4/12 md:w-1/2 w-full">
          مسئول: {epicData?.factory_movie_creator}
        </span>
      )}
      {epicData?.factory_movie_id && (
        <span className="text-md my-2 xl:w-4/12 md:w-1/2 w-full">
          ID فیلم: {epicData?.factory_movie_id}
        </span>
      )}
      {epicData?.factory_movie_language && (
        <span className="text-md my-2 xl:w-4/12 md:w-1/2 w-full">
          زبان: {epicData?.factory_movie_language}
        </span>
      )}
      {epicData?.factory_movie_time && (
        <span className="text-md my-2 xl:w-4/12 md:w-1/2 w-full">
          زمان: {convertSeconds(Number(epicData?.factory_movie_time))}
        </span>
      )}
      {epicData?.factory_subtitle_id && (
        <span className="text-md my-2 xl:w-4/12 md:w-1/2 w-full">
          ID زیرنویس: {epicData?.factory_subtitle_id}{" "}
          <button
            className="btn btn-outline btn-square btn-sm"
            onClick={toggleSubtitleModal}
          >
            <MdModeEditOutline />
          </button>
        </span>
      )}
    </div>
  );
}

export default MovieInfo;
